define([
	"dojo/_base/declare",
	"csi/table/Widget"
], function(declare,Widget) {

	return declare(Widget, {
		_createQueryLevel: function(/*Object*/params, /*Boolean*/bRoot) {
			// summary: allow aggregation of any Classifier
			var	ql = this.inherited(arguments);
			if (ql.bResults && !ql.groupSpec) {
				ql.bCanAggregate = true;
			}
			
			return ql;
		}
	});
});